import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'antd';
import Title from '../../components/Title/Title';
import { ParamsContext } from '../Context/ParamsContext';
import axios from '../../util/Api';
import Table from '../../components/Table/Basic';
import { Link } from 'react-router-dom';
import DateTime from '../../components/Formatter/DateTime';

const Index = (props) => {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(null);

  const params = useContext(ParamsContext);

  useEffect(() => {
    fetchUserList();
  }, [params]);

  const fetchUserList = () => {
    setLoading(true);
    const url = `/user/list`;
    axios.get(url, {params: params}).then(resp => {
      setUsers(resp.data.users);
      setTotal(resp.data.total);
      setLoading(false);
    }).catch(err => {});
  }

  const columns = [
    {
      title: 'Nama',
      dataIndex: 'name',
      key: 'name',
      filter: true,
      sorter: true,
    },
    {
      title: 'Username/Email',
      dataIndex: 'email',
      key: 'email',
      filter: true,
      sorter: true
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: status => status.label
    },
    {
      title: 'Terakhir diperbarui',
      dataIndex: 'updated_at',
      key: 'updated_at',
      sorter: true,
      render: updated_at => <DateTime value={updated_at}/>
    },
    {
      title: '',
      key: 'action',
      render: record => (
        <div className="gx-text-right">
          <Link to={`/users/update?id=${record.id}`} className="gx-mr-1 ant-btn ant-btn-secondary ant-btn-sm">
            Edit
          </Link>
          <Link to={`/users/detail?id=${record.id}`} className="ant-btn ant-btn-secondary ant-btn-sm">
            Detail
          </Link>
        </div>
      )
    },
  ];
  return (
    <>
      <Title>User Admin</Title>
      <div className="m-b-15 m-t-15">
        <Link to="/users/create" className="ant-btn ant-btn-primary">Buat User Baru</Link>
      </div>
      <Table
        columns={columns}
        dataSource={users}
        loading={loading}
        total={total}
      />
    </>
  );
}

export default Index;